import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useParams, useNavigate, Outlet } from 'react-router-dom';
import { PiTrash,  PiMaskHappyLight, PiMaskHappy} from 'react-icons/pi';
import {QuestionDialog, ListItem, createDialog, ContentGroup,Tariffable} from 'coaz-ui';
import EditUserType from './EditUserType';
import AddContextRole from './AddContextRole';
import client from '../client';
import UserItems from './UserItems';


const UserType = () => {
	const {version,setVersion} = useContext(GlobalContext);
	const [userType,setUserType] = useState(null);
	const [current,setCurrent] = useState(null);
	const userTypeRef = useRef(null);
	const [ownerContextRoles,setOwnerContextRoles] = useState([]);
	const [buttons,setButtons] = useState([]);
	const [roleItemButtons,setRoleItemButtons] = useState(null);
	const [details,setDetails] = useState([]);
	const [loading,setLoading] = useState(true);
	const {request,getCurrent,errorMessage} = client;
	const {userTypeId,roleId,userId} = useParams();
	const path = useLocation().pathname;

	const navigate = useNavigate();
	
	const onAssignRole = (e) => {
		if(!userTypeRef.current || !userTypeRef.current.ref || !userTypeRef.current.ref.value) return;
		e.preventDefault();
		createDialog({
			title:"Add Context Role",
			params:{ownerReference:userTypeRef.current.ref.value},
			Component:AddContextRole,
			version:version,
			setVersion:setVersion
		})
	}

	const getUserType = async () => {

		const curr = await getCurrent();

		if(!curr) return;
		setCurrent(curr);

		let updateAuth = curr.authorities.find((auth) => {return auth.authority === 'USERTYPE:UPDATE'});
		let deleteContextAuth = curr.authorities.find((auth) => {return auth.authority === 'CONTEXT:DELETE'});

		if(userTypeId) {
			await request('GET',`user-types/${userTypeId}`)
			.then((response) => {
				if(response) {
					setUserType(response);
					userTypeRef.current = response;
					let btns = [];
					let roleItemBtns = [];

					if(updateAuth) {
						btns.push(
							{
								Icon:PiMaskHappy,
								name:'Assign Role',
								handler:onAssignRole
							}
						);
					}

					if(updateAuth && deleteContextAuth) {
						roleItemBtns.push({
							Icon:PiTrash,
							name:'Delete Context Role',
							handler:onDeleteContextRole
						})
					}

					setButtons(btns);
					setRoleItemButtons(roleItemBtns);
				}  else {
					setUserType(null);
				}
			})
			.catch((error) => {
				setUserType(null);
			})
		}
	}

	const getOwnerContextRoles = async () => {
		if(!userTypeRef.current || !userTypeRef.current.ref) return;
		await request('GET','owner-context-roles/by-owner',null,{ownerReference:userTypeRef.current.ref.value})
		.then((response) => {
			if(response) {
				setOwnerContextRoles(response);
			} else {
				setOwnerContextRoles([])
			}
		})
		.catch((error) => {
			setOwnerContextRoles([])
		})
	}

	const onOpenRole = (item) => {
		if(!item || !item.id) return;
		let ids = item.id.split('-');
		if(ids.length < 3) return;
		navigate(`${path}/_role/${ids[2]}`)
	}

	const onOpenUser = (user) => {
		if(!user || !user.ref || !user.ref.id) return;

		navigate(`${path}/_user/${user.ref.id}`)
	}

	const onDeleteContextRole = (item) => {
		if(!item || !item.id) return;
		
		let id = item.id.split('-');

		if(id && id.length && id.length > 1) {
			createDialog({
				title:'Delete Context Role',
				submitText:"Yes",
				cancelText:"No",
				params:{
					submit:async (e) => {
							try {
								await request('DELETE','owner-context-roles',null,{ownerReference:id[0], contextReference:id[1]});
								return {
									message: 'Successful',
									success: true
								};
							} catch (error) {
								return {
									message: errorMessage(error)
								};
							}
						},
					message:`Are you sure you want to delete ${item.text}?`
				},
				Component:QuestionDialog,
				version:version,
				setVersion:setVersion
			})
		}
	}

	const searchUsers = async (searchKey,page) => {
		let object = null;
		await request('GET','users/filter-page',null,{
			userTypeId:userTypeId,
			searchKey:searchKey,
			pageNo:page.pageNo,
			pageSize:page.pageSize
		})
		.then((response) => {
			if(response && response.content) {
				object = {
					users:response.content,
					pageNo:response.pageNo,
					pageSize:response.pageSize,
					totalElements:response.totalElements,
					totalPages:response.totalPages,
					last:response.last
				}
			} 
		})
		.catch((error) => {
			console.log(error);
		})
		return object
	}

	const load = async () => {
		setLoading(true);
		await getUserType();
		await getOwnerContextRoles();
		setLoading(false);
	}

	useEffect(() => {
		load()
	},[version])

	if(roleId || userId) {
		return (
			<Outlet/>
		)
	} else {
		return (
			<Tariffable
				tariffable={userType}
				current={current}
				request={request}
				errorMessage={errorMessage}
				EditTariffable={EditUserType}
				version={version}
				setVersion={setVersion}
				buttons={buttons}
				setButtons={setButtons}
				details={details}
				loading={loading}
				setLoading={setLoading}
			>
				{ownerContextRoles && ownerContextRoles.length > 0 &&
					<ContentGroup name='Context Roles'>
						{ownerContextRoles.map((ownerContextRole,i) => 
							<ListItem 
								key={i} 
								Icon={PiMaskHappyLight} 
								item={{id:`${ownerContextRole.owner.ref.value}-${ownerContextRole.context}-${ownerContextRole.role.ref.id}`,
										text:ownerContextRole.context.toLowerCase(), 
										subText:ownerContextRole.role.name.toLowerCase(),
									}}
								handleOpen={onOpenRole}
								buttons={roleItemButtons}
							/>)}
					</ContentGroup>
				}
				<ContentGroup name='Users'>
					<UserItems 
						onSelect={onOpenUser}
						search={searchUsers}
					/>
				</ContentGroup>
			</Tariffable>
		)
	}
}

export default UserType
